@if (showBanner) {
<div class="cookie-banner">
  <div class="cookie-content">
    <button
      class="close-btn ms-auto d-md-none p-0"
      style="font-size: 1rem"
      (click)="dismissBanner()"
    >
      ✖
    </button>
    <p class="font-20-16">
      We use cookies to improve and personalize your experience with us. By
      continuing to browse, you are agreeing to our use of cookies
    </p>
    <div class="d-none d-sm-flex flex-column flex-sm-row ms-auto">
      <button class="accept-btn" (click)="acceptCookies()">Accept all</button>
      <button
        class="accept-btn mt-2 mt-sm-0 ms-sm-3"
        style="background-color: var(--orange);color: #000;"
        (click)="necessaryOnly()"
      >
        Strictly necessary
      </button>
      <button
        class="accept-btn mt-2 mt-sm-0 ms-sm-3 bg-black"
        (click)="dismissBanner()"
      >
        Reject all
      </button>
    </div>
    <div class="d-flex flex-column flex-sm-row w-100 d-sm-none">
      <button class="accept-btn w-100" (click)="acceptCookies()">
        Accept all
      </button>
      <button
        class="accept-btn w-100 mt-2"
        style="background-color: var(--orange);color: #000;"
        (click)="necessaryOnly()"
      >
        Strictly necessary
      </button>
      <button class="accept-btn w-100 mt-2 bg-black" (click)="dismissBanner()">
        Reject all
      </button>
    </div>
  </div>
  <button
    class="close-btn d-none d-md-block mb-auto my-xl-auto"
    (click)="dismissBanner()"
  >
    ✖
  </button>
</div>
}
